var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7278 3.10944C12.9251 3.24615 13.0286 3.48246 12.9915 3.71877L11.7416 11.8431C11.7123 12.0326 11.5971 12.1986 11.4291 12.2923C11.2611 12.3861 11.06 12.3978 10.8823 12.3236L8.41567 11.2983L7.63252 12.7532C7.53097 12.9427 7.31419 13.0384 7.10522 12.9856C6.89625 12.9329 6.74978 12.7454 6.74978 12.5306V10.6557C6.74978 10.5522 6.78493 10.4507 6.84938 10.3686L10.0776 6.21662C10.1265 6.07796 9.9507 5.93735 9.82376 6.05257L6.32794 9.21444L5.70299 9.77885C5.52331 9.94094 5.26747 9.98586 5.04288 9.89212L3.38285 9.20077C3.16412 9.10898 3.01569 8.90196 3.00202 8.6637C2.98835 8.42543 3.10944 8.20084 3.31645 8.08171L12.0658 3.0821C12.2747 2.96297 12.5325 2.97469 12.7298 3.10944H12.7278Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.eeaba55a8e9bb33f7136f3f645bf7e96.svg";
export { ForwardRef as ReactComponent };